import {Alert} from 'src/design/atoms/Alert';
import React from 'react';
import type {TaskParticipationStatistics} from 'src/api/ProactApiClient';

export interface TaskParticipationBannerProps {
  item?: TaskParticipationStatistics;
}

export const TaskParticipationBanner: React.FC<
  TaskParticipationBannerProps
> = ({item}) => {
  return (
    item &&
    item.total > 0 && (
      <Alert color="green" mb="md">
        {`Overall Participation: ${Math.floor(item.completed)} / ${Math.floor(
          item.total
        )} = ${Math.floor((item.completed / item.total) * 100)}%`}
      </Alert>
    )
  );
};
